import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageShell from '../components/LegalPageShell';
import LEGAL_DETAILS from '../config/legal';
import SEO from '../components/SEO';
import { SEO_TEXTES } from '../data/seoTextes';

const collectedData = [
  'nom',
  'adresse e-mail',
  'identifiant de compte',
  "photo de profil, si elle est fournie par Google et utilis\u00e9e par l'application",
];

const usageData = [
  "authentifier l'utilisateur",
  'cr\u00e9er ou relier son compte',
  "s\u00e9curiser l'acc\u00e8s aux services",
  "am\u00e9liorer l'administration du compte",
];

const rightsData = [
  "droit d'acc\u00e8s \u00e0 vos donn\u00e9es",
  'droit de rectification',
  'droit de suppression, sous r\u00e9serve des obligations l\u00e9gales et techniques applicables',
  "droit de nous contacter pour toute question relative au traitement de vos donn\u00e9es",
];

const contactDetails = [
  { label: 'Soci\u00e9t\u00e9', value: LEGAL_DETAILS.companyName },
  { label: 'Email', value: LEGAL_DETAILS.contactEmail },
  { label: 'Site web', value: LEGAL_DETAILS.website },
];

function BulletList({ items }) {
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li key={item} className="flex gap-3 text-slate-300 leading-relaxed">
          <span className="mt-2 h-2 w-2 rounded-full bg-[#0099D6] flex-shrink-0" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

function DetailList({ items }) {
  return (
    <dl className="space-y-4">
      {items.map((item) => (
        <div key={item.label} className="border-b border-white/5 pb-4 last:border-b-0 last:pb-0">
          <dt className="text-sm uppercase tracking-[0.18em] text-slate-500 mb-1">{item.label}</dt>
          <dd className="text-base text-slate-200">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export default function PrivacyPolicy() {
  return (
    <>
      <SEO {...SEO_TEXTES['/politique-confidentialite']} path="/politique-confidentialite" />
    <LegalPageShell
      testId="privacy-policy-page"
      title={'Politique de confidentialit\u00e9'}
      subtitle={'METERIS attache une importance particuli\u00e8re \u00e0 la protection des donn\u00e9es personnelles et \u00e0 une utilisation mesur\u00e9e des informations n\u00e9cessaires \u00e0 l\u2019authentification.'}
      updatedAt={LEGAL_DETAILS.updatedAt.privacy}
    >
      <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
        <h2 className="text-2xl font-semibold text-white mb-4">{'Donn\u00e9es concern\u00e9es'}</h2>
        <p className="text-slate-300 leading-relaxed mb-5">
          {'Lors de l\u2019utilisation de la connexion Google, certaines informations peuvent \u00eatre collect\u00e9es pour permettre une identification fiable et un acc\u00e8s s\u00e9curis\u00e9 aux services METERIS.'}
        </p>
        <BulletList items={collectedData} />
      </section>

      <div className="grid gap-6 lg:grid-cols-2">
        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">Utilisation</h2>
          <p className="text-slate-300 leading-relaxed mb-5">
            {'Les donn\u00e9es collect\u00e9es sont utilis\u00e9es uniquement pour :'}
          </p>
          <BulletList items={usageData} />
        </section>

        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">{'Partage des donn\u00e9es'}</h2>
          <p className="text-slate-300 leading-relaxed">
            {'METERIS ne vend pas les donn\u00e9es personnelles. Elles ne sont partag\u00e9es qu\u2019en cas de n\u00e9cessit\u00e9 technique, d\u2019obligation l\u00e9gale ou d\u2019exigence de s\u00e9curit\u00e9 strictement justifi\u00e9e.'}
          </p>
        </section>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">{'Conservation des donn\u00e9es'}</h2>
          <p className="text-slate-300 leading-relaxed">
            {'Les donn\u00e9es sont conserv\u00e9es pendant une dur\u00e9e adapt\u00e9e \u00e0 la gestion du compte, \u00e0 la s\u00e9curisation des acc\u00e8s et au respect des obligations applicables. Lorsque leur conservation n\u2019est plus n\u00e9cessaire, elles sont supprim\u00e9es ou archiv\u00e9es selon les contraintes l\u00e9gales et techniques en vigueur.'}
          </p>
        </section>

        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">Vos droits</h2>
          <BulletList items={rightsData} />
        </section>
      </div>

      <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
        <h2 className="text-2xl font-semibold text-white mb-4">{'Cookies et mesure d\u2019audience'}</h2>
        <p className="text-slate-300 leading-relaxed">
          {"Sur meteris.fr, Matomo mesure la fréquentation de façon anonyme et sans cookie tant que vous n'avez pas fait de choix. Il ne dépose ses cookies que si vous les acceptez via le bandeau cookies ; si vous refusez, plus aucune mesure d'audience n'a lieu."}
        </p>
        <p className="mt-4 text-slate-300 leading-relaxed">
          {'Le détail des traceurs utilisés et la gestion de vos préférences sont disponibles dans la '}
          <Link to="/cookies" className="text-[#7DDCFF] transition-colors hover:text-white">
            politique de cookies
          </Link>
          .
        </p>
      </section>

      <section className="rounded-3xl border border-white/5 bg-[#0F1117]/90 p-8 md:p-10">
        <h2 className="text-2xl font-semibold text-white mb-4">Contact</h2>
        <p className="text-slate-300 leading-relaxed mb-6">
          {'Pour toute demande relative \u00e0 cette politique de confidentialit\u00e9 ou \u00e0 vos donn\u00e9es personnelles, vous pouvez contacter METERIS via les informations ci-dessous.'}
        </p>
        <DetailList items={contactDetails} />
        <p className="text-slate-400 leading-relaxed mt-6">
          {'Cette politique peut \u00eatre mise \u00e0 jour afin de refl\u00e9ter une \u00e9volution de nos pratiques, de nos services ou de nos obligations.'}
        </p>
      </section>
    </LegalPageShell>
    </>
  );
}
